interface AuthFooterProps {
  displayName?: string;
  divider?: boolean;
}

const AuthFooter = ({ displayName, divider = false }: AuthFooterProps) =>
  divider ? (
    <div className="pt-6 text-center border-t border-slate-100 mt-6">
      <p className="text-slate-400 text-xs font-medium">
        {displayName} &bull; Powered by Skuulbe
      </p>
    </div>
  ) : (
    <div className="pt-4 text-center">
      <p className="text-gray-secondary text-xs manrope-medium">
        {displayName} &bull; Powered by Skuulbe
      </p>
    </div>
  );

export default AuthFooter;
